var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('menu-item',{attrs:{"icon":_vm.icon,"to":_vm.to,"i18n":_vm.i18n,"counter":16}})}
var staticRenderFns = []

export { render, staticRenderFns }